<template>
  <el-dialog custom-class="max-dialog1256" title="盘点单" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false"
             :append-to-body="true">
    <el-form :model="form" ref="form1" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="10">
          <el-form-item label="仓库" :label-width="formLabelWidth" prop="cangkucode" size="small"
                        style="text-align: left;">
            <template>
            <el-select v-model="form.cangkuname" placeholder="请选择" @change="changename" style="width: 130px"
                       :required="true" >
              <el-option
                v-for="item in jxcstoreDataf"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item">
              </el-option>
            </el-select>
            <el-select v-model="form.warehouse" size="mini" style="width: 100px" v-if="warehouse.length>1&&form.cangkucode" @change="changewarehouse">
            <el-option v-for="item in warehouse" :key="item.serial" :label="item.name" :value="item.serial"></el-option>
             </el-select>
            </template>
            <!--<span v-else>{{form.cangkuname}}&nbsp;&nbsp;{{form.warehousename}}&nbsp;&nbsp;{{form.accdate}}</span>-->
          </el-form-item>
        </el-col>
        <el-col :span="14">
          <el-form-item label="货品名称" :label-width="formLabelWidth" prop="seedname" size="small"
                        style="text-align: left;">
            <CommonTree ref="treeSeed" :defineDataSource="true" @bindData="bindData" :isShowCheckBox="false"
                        v-model="form.seedname" :treeWidth="340"
                        :treeHeight="350" :searchText="form.seedname"
                        @check="checktree1"></CommonTree>
            <!--<span v-else>{{form.seedname}}</span>-->
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="说明" :label-width="formLabelWidth">
            <el-input
              type="textarea"
              :rows="1"
              v-model="form.remark">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-show="false">
        <el-col :span="10">
          <el-form-item label="盘点日期" :label-width="formLabelWidth" prop="accdate">
            <el-input v-model="form.accdate" auto-complete="off" :required="true" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="10">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span style="line-height: 28px">库存量</span>
              <span style="float: right; padding-right: 20px" >库存：{{totalnumber.P}}、盘点：{{totalnumber.N}}、差异：{{totalnumber.D}}</span>
              <!--<el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button>-->
            </div>
            <el-table
              :data="storeData"
              :height="tableHeight(325)"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                prop="type"
                align="right"
                header-align="center"
                label="R/L" width="70">
              </el-table-column>
              <el-table-column
                prop="Y"
                align="right"
                header-align="center"
                label="球镜" width="70">
              </el-table-column>
              <el-table-column
                prop="X"
                align="right"
                header-align="center"
                label="柱镜" width="70">
              </el-table-column>
              <el-table-column
                prop="P"
                align="right"
                label="库存量" width="70">
              </el-table-column>
              <el-table-column
                prop="N"
                align="right"
                label="盘点量" width="70">
              </el-table-column>
              <el-table-column
                prop="D"
                align="right"
                label="差异" width="70">
                <template slot-scope="scope">
                  <div style="width: 70px;line-height: 24px;background-color: #409EFF;padding-right: 20px;color: white" v-if="scope.row.D>0"><b>{{scope.row.D}}</b></div>
                  <div style="width: 70px;line-height: 24px;background-color: #F56C6C;padding-right: 20px;color: white" v-if="scope.row.D<0"><b>{{scope.row.D}}</b></div>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
        <el-col :span="14">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>盘点量</span>
              <el-input style="width: 260px;float: right;padding-right: 20px" ref="inputScan"   v-if="btnvisible" size="mini" v-model="storegoodsbarcode" placeholder="扫唯一码"  onfocus="this.select()" @keyup.enter.native="getZyanjingQRCode()"></el-input>
              <!--<el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button>-->
            </div>
            <el-table
              :data="scancodes"
              :height="tableHeight(325)"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                align="center"
                header-align="center"
                label="序号" width="70">
                <template slot-scope="scope">
                  {{scancodes.length-scope.$index}}
                </template>
              </el-table-column>
              <el-table-column
                prop="type"
                align="right"
                header-align="center"
                label="R/L" width="70">
              </el-table-column>
              <el-table-column
                prop="Y"
                align="right"
                header-align="center"
                label="球镜" width="70">
              </el-table-column>
              <el-table-column
                prop="X"
                align="right"
                header-align="center"
                label="柱镜" width="70">
              </el-table-column>
              <el-table-column
                prop="storegoodsbarcode"
                align="center"
                header-align="center"
                label="唯一码" width="200">
              </el-table-column>
              <el-table-column
                prop="starttime"
                align="center"
                header-align="center"
                label="日期" width="100">
              </el-table-column>
              <el-table-column
                prop="D"
                align="right"
                header-align="center"
                label="操作" width="70">
                <template slot-scope="scope">
                  <el-button size="mini" type="info" plain @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" v-if="btnvisible" :loading="loading">保 存</el-button>
    </div>
  </el-dialog>
</template>


<script>
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {getGoodsTree} from '@/api/set/jxcgooddetail';
  import TwoDimensionalTable from '@/components/set/goodsprice/TwoDimensionalTable';
  import {getControlData,getPrice} from '@/api/set/goodsprice';
  import {inventorySave} from '@/api/set/jxcstoreform';
  import {looklist} from '@/api/set/jxcstoreformdetail';
  import {getGoodsListWithStoreDetail} from '@/api/set/jxcresultstore';
  import {getQRCode} from '@/api/set/jxcstoregoodsbar';

  export default {
    name: 'MakeInventoryScanEdit',
    msg: '盘点单',
    data() {
      return {
        addvisible: true,
        loading:false,
        guids: '',//商品编码
        storeData:[],
        dialogFormVisible: false,
        warehouse:[],
        storegoodsbarcode:'',
        totalnumber:{},
        form: {  //表单数据
          accdate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
          cangkucode: '',
          cangkuname: '',
          packagesizes: '',
          seedcode: '',
          seedname: '',
          status: 10,
          formtype: 74,
          filltemplate: '',
          remark: '',
          totalnumber: 0,
          physicalstore:'',
          physicalstorecode:'',
          warehouse:'',
          warehousename:'',
          jxcstoregoodsbar:''
        },
        jxcstoreDataf: [],//仓库
        scancodes: [],//存储盘点数据
        formLabelWidth: '120px',
        btnvisible: false,//控制确定按钮显示、隐藏
        rules: {////////定义正则验证字段。
          cangkucode: [
            {required: true, message: '请选择仓库', trigger: 'blur'},
          ],
          seedname: [
            {required: true, message: '请选择货品', trigger: 'change'},
          ],
        },
      }
    },
    methods: {
      handleDelete(index,item) {
        this.scancodes.splice(index,1);
        for(let j in this.storeData) {
          var rows = this.storeData[j];
          if (parseFloat(rows.X) == parseFloat(item.X) && parseFloat(rows.Y) == parseFloat(item.Y)) {
            rows.N += -1;
            rows.D += -1;
            this.totalnumber.N+=-1;
            this.totalnumber.D+=-1;
            break;
          }
        }
      },
      getZyanjingQRCode() {//平台自己生成的二维码
        if (!this.storegoodsbarcode) return;
        this.storegoodsbarcode = this.storegoodsbarcode.replace(/……/g, '^');
        var qrcodeLen = this.storegoodsbarcode.split('^');
        var qrcode = qrcodeLen[qrcodeLen.length - 1]
        this.storegoodsbarcode = '';
        getQRCode({storegoodsbarcode: qrcode}).then(response => {
          if (response.data.code == 0 && response.data.obj) {
            var arr = response.data.obj;
            if (arr.used == 1) {
              //已出库 新增
            } else {
              //未出库的所属仓库要对
              if (this.form.cangkucode != arr.cangkucode) {
                this.errorAlert('商品【' + qrcode + '】所属仓库不正确！');
                return;
              }
            }
            if (this.form.seedcode != arr.seedcode) {
              this.errorAlert('唯一码【' + qrcode + '】所属商品不匹配！');
              return;
            }
            for (let j in this.scancodes) {
              if (this.scancodes[j].storegoodsbarcode == qrcode) {
                this.error('重复扫码【' + qrcode + '】！')
                return;
              }
            }

            var pg = JSON.parse(arr.packagesize)
            arr.Y = pg.Y;
            arr.X = pg.X;
            if (pg.type)
              arr.type = pg.type;
            var hasValue = false;
            for (let j in this.storeData) {
              var rows = this.storeData[j];
              if (parseFloat(rows.X) == parseFloat(arr.X) && parseFloat(rows.Y) == parseFloat(arr.Y) && (!pg.type || (pg.type && arr.type == rows.type))) {
                rows.N += 1;
                rows.D += 1;
                this.totalnumber.N += 1;
                this.totalnumber.D += 1;
                hasValue = true;
                break;
              }
            }
            arr.starttime = this.formatDate(arr.starttime);
            this.scancodes.unshift(arr);
            if (!hasValue) {//库存中不存在的补一条
              var row = {
                X: arr.X, Y: arr.Y, P: 0, N: 1, D: 1
              };
              if (pg.type) {
                row.type = pg.type;
              }
              this.storeData.push(row);
              this.sortStore();
            }
          } else {
            this.errorAlert('无效条码！')
          }
        });
      },
      show() {
        this.dialogFormVisible = true;
      },
      formatDate(date) {
        if (!date)
          return '';
        var myDate = new Date(date);
        return this.setTimeZero(myDate.getFullYear()) + '-'+(this.setTimeZero(myDate.getMonth() + 1)) + '-' + this.setTimeZero(myDate.getDate());
      },
      saveData() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            this.loading = true
            //一个二维表,过滤数量为空和0
            //10现片，20定制片，30区分左右眼
            //存储二维表过滤后的数据
            var arr = [];
            for (let i in this.storeData) {
              if (this.storeData[i].D != 0) {
                var row={
                  X: this.storeData[i].X,
                  Y: this.storeData[i].Y,
                  P: this.storeData[i].D
                };
                if(this.storeData[i].type)
                  row.type=this.storeData[i].type;
                arr.push(row);
              }
            }
            if (arr.length == 0) {
              arr.push({
                X: '0.00',
                Y: '0.00',
                P: 0
              });
            }

            var storbars = '';
            for (let i in this.scancodes) {
              storbars += this.scancodes[i].storegoodsbarcode + ";";
            }

            this.form.jxcstoregoodsbar = storbars;
            this.form.packagesizes = JSON.stringify(arr);
            this.form.physicalstore = this.form.seedname
            this.form.physicalstorecode = this.form.seedcode
            this.form.remark = (this.form.remark || '') + " 盘点：" + this.totalnumber.N + "、库存：" + this.totalnumber.P + "、" + (this.totalnumber.D == 0 ? '无差异！' : ((this.totalnumber.D > 0 ? '盘盈：' : '盘亏：') + this.totalnumber.D + "！"));
            inventorySave(this.form).then(response => {
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.dialogFormVisible = false;

              //刷新列表
              this.$emit('bindGrid');
            });
          }
        });
      },
      //初始化
      initForm() {
        this.storeData = []
        if (this.$refs.form1 !== undefined) {
          this.$refs.form1.resetFields();
          this.form.seedname = ""
          this.form.seedcode = ""
          this.form.discountdetail = ""
          this.form.remark = ''
          this.form.totalnumber = {}
          this.form.cangkucode = ''
          this.form.cangkuname = ''
        }
        this.scancodes=[]
        this.loading = false
        this.btnvisible = false;
        this.form.enabled = 1
        this.index = ''
        cusandptbyind().then(response => {
          this.jxcstoreDataf = response.data.obj
          if (this.jxcstoreDataf.length == 1) {
            this.changename(this.jxcstoreDataf[0]);
          }

        })
      },
      //商品树
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({nostock: 1, filltemplates: '10;20;30'})
        })
      },
      //选择商品树所执行的方法
      checktree1(guids, names, arr) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i]['attributes']['filltemplate']) {
            this.form.filltemplate = arr[i]['attributes']['filltemplate']
            break
          }
        }
        this.form.seedcode = guids//商品编码
        this.form.seedname = names//商品名称
        if (this.form.seedname == "") {
          this.$message({
            message: '请选择货品',
            type: 'warning'
          })
          return
        }
        this.createPriceBook()
      },
      changewarehouse(val) {
        this.form.warehouse = val;
        for (let i in this.warehouse) {
          if (this.warehouse[i].serial == val) {
            this.form.warehousename = this.warehouse[i].name;
            break;
          }
        }
        if (this.form.seedcode)
          this.createPriceBook()
      },
      changename(val) {
        this.form.cangkucode = val.cangkucode;
        this.form.cangkuname = val.cangkuname;
        this.warehouse = [];
        this.form.warehouse = '';
        this.form.warehousename = '';
        if (val.warehouse) {
          this.warehouse = JSON.parse(val.warehouse);
          if (this.warehouse <= 1) {
            this.warehouse = [];
          } else {
            this.form.warehouse = this.warehouse[0].serial;
            this.form.warehousename = this.warehouse[0].name;
          }
        }
        if (this.form.seedcode)
          this.createPriceBook();
      },
      createPriceBook() {
        let yearnow = new Date().getFullYear()
        let monthnow = new Date().getMonth() + 1;
        this.storeData = [];
        this.btnvisible = true;
        this.scancodes = [];
        //取当前库存
        getGoodsListWithStoreDetail({
          seedcode: this.form.seedcode, warehouse: this.form.warehouse,
          cangkucode: this.form.cangkucode,
          minyear: yearnow,
          minmonth: monthnow,
          maxyear: yearnow,
          maxmonth: monthnow,
          nostock: 1, nolimit: '1', notransfernum: '1', nodeliverying: '1', nobuynum: '1'
        }).then(resStore => {

          var storeData = resStore.data.obj;
          for (let i in storeData) {
            if (storeData[i].subtractnum == 0) continue;
            var pc = JSON.parse(storeData[i].packagesize)
            var row = {
              X: pc.X,
              Y: pc.Y,
              P: storeData[i].subtractnum,
              N: 0,
              D: -storeData[i].subtractnum
            }
            if (pc.type)
              row.type = pc.type;
            this.storeData.push(row);
          }
          this.sortStore();
          this.scanFoucs();
        });
      },
      errorAlert(msg){
        this.$alert(msg, '异常', {
          confirmButtonText: '确定',
          type: 'error',
          callback: action => {
            this.scanFoucs();
          }
        });
      },
      scanFoucs(){
        this.$nextTick(() => {
          if (this.$refs.inputScan)
            this.$refs.inputScan.focus();
        })
      },
      setTimeZero(value) {
        return value > 9 ? value : '0' + value;
      },
      error(msg, id) {
        this.$message({
          message: msg,
          type: 'error'
        })
      },
      sortStore() {
        var arr = {P: 0, N: 0, D: 0};
        for (let i in this.storeData) {
          arr.P += this.storeData[i].P;
          arr.N += this.storeData[i].N;
          arr.D += this.storeData[i].D;
        }
        this.totalnumber = arr;

        this.storeData.sort(function (a, b) {
          if (parseFloat(a.Y)> parseFloat(b.Y))
            return -1;
          else if (parseFloat(a.Y) < parseFloat(b.Y))
            return 1;
          else{

            if (parseFloat(a.X) > parseFloat(b.X))
              return -1;
            else if (parseFloat(a.X) < parseFloat(b.X))
              return 1;
            else
              return 0;

          }
        });
      },
    },
    components: {
      TwoDimensionalTable//商品树注册
    },

    mounted() {
    },
  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 40px;
    line-height: 40px;
    padding: 2px;
  }

  .erweitable td {
    border: 1px solid #E0DFDF;
    min-width: 80px;
    max-width: 100px;
    text-align: center;
    vertical-align: center;
  }

  .erweitable .content {
    border: none;
    padding: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/components/warehouse/MakeInventoryScanEdit.vue